var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.template.tenantId ? _c('core-dtwin-rule-table', {
    ref: "rulesTable",
    attrs: {
      "template": _vm.template,
      "hasTwinEditPermission": true,
      "hasTwinManagePermission": true,
      "templateContext": true,
      "isProductiveVersion": _vm.isProductiveVersion,
      "readonly": _vm.readonly
    },
    on: {
      "update-unsaved-changes": _vm.emitUnsavedChanges
    },
    model: {
      value: _vm.template.stateDefinition,
      callback: function ($$v) {
        _vm.$set(_vm.template, "stateDefinition", $$v);
      },
      expression: "template.stateDefinition"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };